import { render, staticRenderFns } from "./card-popup.vue?vue&type=template&id=3f5425fd&scoped=true&lang=html"
import script from "./card-popup.vue?vue&type=script&lang=js"
export * from "./card-popup.vue?vue&type=script&lang=js"
import style0 from "./card-popup.vue?vue&type=style&index=0&id=3f5425fd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5425fd",
  null
  
)

export default component.exports